<template>
    <div class="checkout-contact-sova-club">
        <def-input
            :name="result.inputName"
            :value="result.VALUE || ''"
            :placeholder="result.NAME"
            :key="result.CODE"
            :isError="isError"
            :pattern="isError ? 'fixedpattern': null"
            :required="isError"
            ref="input"
            @blur="handlerBlurSovaClub"
        />
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import { useStore } from 'vuex';

const { result } = defineProps(['result']);

const { dispatch } = useStore();

let isError = ref(false);
const input = ref(null);


const handlerBlurSovaClub = async ({ target }) => {
    const data = await dispatch('basket/setCoupon', target.value);
    const clubCard = data.price.clubCard;

    if (target.value.trim()) {
        if (
            clubCard &&
            !(target.value in clubCard) &&
            Object.keys(clubCard).length
        ) {
            await dispatch('basket/deleteCoupon', Object.keys(clubCard)[0]);
        } else if(!clubCard) {
            isError.value = true;
            input.value.isValid = false;
        }
    } else {
        input.value.isValid = true;
        isError.value = false;
    }

    // dispatch('checkout/setAjax');
}
</script>

<script>
export default {
    name: 'CheckoutContactSovaClub',
}
</script>

<style lang="scss" scoped>
.checkout-contact-sova-club{

}
</style>